import { UseQueryOptions } from '@tanstack/react-query';
import { urlCombine } from 'ihub/common';
import { coreAPI, isURLSet, standardGet, validateOkResponse } from '../classes/http-helper-const';

export class ChatHttpService {
	getStatus(): UseQueryOptions<{ configured: boolean }, unknown, { configured: boolean }> {
		return {
			queryKey: ['chat-status'],
			queryFn: async (): Promise<{ configured: boolean }> => {
				isURLSet();
				const url = urlCombine(coreAPI, 'chat', 'status');
				const res = await standardGet(url);
				await validateOkResponse(res, 'get', 'Chat Status');
				return res.clone().json();
			},
			staleTime: Infinity,
		};
	}
}
